module.exports = __webpack_public_path__ + "static/media/outline.97a143d6.svg";